function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M7.5 8L42 2.6 76.5 8l.5 23.9c.4 21-11.1 40.3-29.8 50L42 84.6l-5.2-2.7c-18.6-9.6-30.2-29-29.8-50L7.5 8z",
  opacity: 0.1,
  fill: "#7f63ff"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M39.4 76.8C22.5 68.1 12.3 50.9 12.7 32l.4-19.1L42 8.3l28.9 4.6.4 19.1c.4 18.9-9.9 36.1-26.7 44.8L42 78.2l-2.6-1.4z",
  opacity: 0.25,
  fill: "none",
  stroke: "#7f63ff"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M7.5 8L42 2.6 76.5 8l.5 23.9c.4 21-11.1 40.3-29.8 50L42 84.6l-5.2-2.7c-18.6-9.6-30.2-29-29.8-50L7.5 8z",
  opacity: 0.5,
  strokeWidth: 3,
  fill: "none",
  stroke: "#7f63ff"
});

function SvgShield(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 88
  }, props), _ref, _ref2, _ref3);
}

export default __webpack_public_path__ + "41f4ab5e953d2bb17aa0d5afe2610a49.svg";
export { SvgShield as ReactComponent };